import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../utils/cn';

// PendingBackendNotice — dashed-border pill marking a feature that is built
// in the UI but waiting on backend. Used across settings sections.
//
// Props:
//   - children?: ReactNode (custom message)
//   - icon?: ReactNode (override default Lock)
//   - className?: string

export function PendingBackendNotice({ children, icon, className }) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border border-dashed border-border bg-bg px-3 py-2 text-xs text-fg-muted',
        className,
      )}
      role="note"
    >
      {icon ?? <Lock className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />}
      <span>{children ?? t('Funcionalidad en construcción.')}</span>
    </div>
  );
}

PendingBackendNotice.displayName = 'PendingBackendNotice';

export default PendingBackendNotice;
